import { ComponentProps, FC, Ref } from 'react';

import { IconName, Size } from '@purpur/library/icon';

import { getSvgIcon } from '@telialt/common-icon/src';

import { TextButton } from './TextButton';
import { StyledIcon } from './TextButton.styles';

type Props = ComponentProps<typeof TextButton> & {
    icon: IconName | string;
    iconPosition?: 'left' | 'right';
    iconSize?: Size;
    hasExtraSpacing?: boolean;
    ref?: Ref<HTMLAnchorElement>;
};

export const TextButtonWithIcon: FC<Props> = ({
    icon,
    iconPosition = 'left',
    iconSize = 'xs',
    hasExtraSpacing,
    children,
    className,
    onClick,
    dataTest,
    ref,
    ...props
}) => {
    const iconsSvg = getSvgIcon(icon);

    return (
        <TextButton {...props} className={className} onClick={onClick} dataTest={dataTest} ref={ref}>
            {iconPosition === 'left' && (
                <StyledIcon
                    svg={iconsSvg}
                    size={iconSize}
                    $iconPosition={iconPosition}
                    $hasExtraSpacing={hasExtraSpacing}
                />
            )}
            {children}
            {iconPosition === 'right' && (
                <StyledIcon
                    svg={iconsSvg}
                    size={iconSize}
                    $iconPosition={iconPosition}
                    $hasExtraSpacing={hasExtraSpacing}
                />
            )}
        </TextButton>
    );
};
